module.exports = __webpack_public_path__ + "img/google_store.10d72f8.png";